import { render, staticRenderFns } from "./monopolyDicesDetail.vue?vue&type=template&id=7aed8b96"
import script from "./monopolyDicesDetail.vue?vue&type=script&lang=js"
export * from "./monopolyDicesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports